import { Component, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  standalone: true,
  selector: "app-checkout",
  template: `<nes-heading class="nes-mb-3" size="600">
      {{ "CHECKOUT.TITLE" | translate }}
    </nes-heading>
    <nes-text-list>
      <nes-text-list-item>{{ "CHECKOUT.BULLETS.1" | translate }}</nes-text-list-item>
      <nes-text-list-item>{{ "CHECKOUT.BULLETS.2" | translate }}</nes-text-list-item>
      <nes-text-list-item>{{ "CHECKOUT.BULLETS.3" | translate }}</nes-text-list-item>
    </nes-text-list>`,
  imports: [TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CheckoutComponent {}
